export default {
    title: 'تسجيل ',
    username: 'اسم المستخدم',
    describeYourself: 'اوصف نفسك',
    describeOthers: 'اوصف الشريك',
    uploadImages: 'تحميل الصور',
    presentYourself: 'قدم نفسك من خلال صورك',
    pickFile: 'حمل الملف',
    contactWaysTitle: 'اختار طريقة التواصل'
}
